import React, { useEffect, useRef } from "react";

function AudioPlayer({ playing, tracks, trackIdx, setTrackIdx }) {
  const audioRef = useRef(null);
  const fadeInterval = useRef(null);

  const fadeVolume = (direction, callback) => {
    clearInterval(fadeInterval.current);
    const audio = audioRef.current;
    if (!audio) return;

    const step = 0.05;
    const delay = 50;
    fadeInterval.current = setInterval(() => {
      if (direction === "out") {
        audio.volume = Math.max(0, audio.volume - step);
        if (audio.volume <= 0) {
          clearInterval(fadeInterval.current);
          callback?.();
        }
      } else {
        audio.volume = Math.min(1, audio.volume + step);
        if (audio.volume >= 1) {
          clearInterval(fadeInterval.current);
        }
      }
    }, delay);
  };

  // Change track when trackIdx updates
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.src = tracks[trackIdx];
    audio.volume = 1;

    if (playing) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  }, [trackIdx]);

  // Pause logic with fade
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (playing) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
      fadeVolume("out", () => {
        audio.volume = 1;
      });
    }
  }, [playing]);

  // Handle auto-play next track when one ends
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleEnded = () => {
      if (tracks.length > 1) {
        const nextIndex = (trackIdx + 1) % tracks.length;
        setTrackIdx(nextIndex);
      }
    };

    audio.addEventListener("ended", handleEnded);
    return () => {
      audio.removeEventListener("ended", handleEnded);
    };
  }, [trackIdx, tracks, setTrackIdx]);

  return (
    <audio
      ref={audioRef}
      preload="auto"
      style={{ display: "none" }}
    />
  );
}

export default AudioPlayer;
